import "@babel/polyfill";
import $ from 'jquery';
import loader from './__modules/loader';
import menu from "./__modules/menu";
import scroll_to_top from "./__modules/scroll-to-top";
import textHeight_slider from "./__modules/slider-cell-textHeight";
import play_story_btn from "./__modules/play-story-btn";
import accordion from "./__modules/accordion";
import radio_live from "./__modules/radio-live";
import about_purpose from "./__modules/about-purpose-nav";
document.addEventListener('DOMContentLoaded', () => {
    about_purpose();
    loader();
    menu();
    textHeight_slider();
    accordion();
    radio_live();
});
window.addEventListener('load', () => {
    scroll_to_top();
    play_story_btn();

});
window.addEventListener('resize', () => {
});
window.addEventListener('scroll', () => {
});